(function() {

    document.querySelectorAll('.adev-scrollable-videos').forEach(function(root) {

        const baseCount = root.dataset.blockCount || 0;

        var track = root.querySelector('[data-vid-track]');
        var items = Array.prototype.slice.call(track.querySelectorAll('.vid-item'));
        if (!items.length) return;

        function centeredItem() {
            var c = track.scrollLeft + track.clientWidth / 2,
                best = null,
                bd = Infinity;
            items.forEach(function(it) {
                var d = Math.abs((it.offsetLeft + it.offsetWidth / 2) - c);
                if (d < bd) {
                    bd = d;
                    best = it;
                }
            });
            return best;
        }

        function setActive(active) {

            items.forEach(function(it) {
                // const videoTag = it.querySelector('video');
                var v = it.querySelector('video');
                if (it === active) {
                    it.classList.add('is-active');

                    if (typeof it.play === 'function') {
                        it.play();
                    } else {
                        it.addEventListener('adev:ready', function() {
                            it.play();
                        });
                    }
                } else {
                    it.classList.remove('is-active');
                    
                    if (typeof it.pause === 'function') {
                        it.pause();
                    } else {
                        it.addEventListener('adev:ready', function() {
                            it.pause();
                        });
                    }
                }
            });
        }

        function centerOn(item, smooth) {
            track.scrollTo({
                left: item.offsetLeft - (track.clientWidth - item.offsetWidth) / 2,
                behavior: smooth ? 'smooth' : 'auto'
            });
        }

        function maybeLoop() {
            if (items.length <= baseCount) return;
            var c = centeredItem();
            if (c.dataset.set === "1") return;
            var twin = items.filter(function(it) {
                return it.dataset.base === c.dataset.base && it.dataset.set === "1";
            })[0];
            if (twin) track.scrollLeft += (twin.offsetLeft - c.offsetLeft);
        }

        function step(dir) {
            var c = centeredItem(),
                i = items.indexOf(c),
                n = items[i + dir];
            if (n) centerOn(n, true);
        }

        // Arrow buttons
        var prev = root.querySelector('[data-prev]'),
            next = root.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', function() {
            step(-1);
        });
        if (next) next.addEventListener('click', function() {
            step(1);
        });

        // Mouse wheel -> horizontal scroll (desktop)
        track.addEventListener('wheel', function(e) {
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                track.scrollLeft += e.deltaY;
                e.preventDefault();
            }
        }, {
            passive: false
        });

        // Click + drag to scroll
        var down = false,
            startX = 0,
            startScroll = 0,
            moved = false;
        track.addEventListener('pointerdown', function(e) {
            down = true;
            moved = false;
            startX = e.clientX;
            startScroll = track.scrollLeft;
            track.classList.add('is-dragging');
        });
        window.addEventListener('pointermove', function(e) {
            if (!down) return;
            var dx = e.clientX - startX;
            if (Math.abs(dx) > 4) moved = true;
            track.scrollLeft = startScroll - dx;
        });
        window.addEventListener('pointerup', function() {
            if (!down) return;
            down = false;
            track.classList.remove('is-dragging');
            if (moved) {
                maybeLoop();
                centerOn(centeredItem(), true);
                // alert('pointerup: centering on');
                setActive(centeredItem());
            }
        });

        // Settle on scroll
        var settle;
        track.addEventListener('scroll', function() {
            clearTimeout(settle);
            settle = setTimeout(function() {
                maybeLoop();
                // alert('scroll: centering on');
                setActive(centeredItem());
            }, 110);
        });

        window.addEventListener('load', function() {

            var mid = items.filter(function(it) {
                return it.dataset.set === "1";
            });

            const io = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        var startItem = mid[Math.floor(mid.length / 2)] || items[Math.floor(items.length / 2)];
                        centerOn(startItem, false);
                        setActive(startItem);
                        
                        io.unobserve(root);
                    }
                });
            }, {
                root: null,
                rootMargin: '0px',
                threshold: 0.5
            });

            io.observe(root);

            

            
        });

    });

})();